import { render, staticRenderFns } from "./points-plan-detail.vue?vue&type=template&id=34206d00&scoped=true&"
import script from "./points-plan-detail.vue?vue&type=script&lang=js&"
export * from "./points-plan-detail.vue?vue&type=script&lang=js&"
import style0 from "./points-plan-detail.vue?vue&type=style&index=0&id=34206d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34206d00",
  null
  
)

export default component.exports